export const OptioPayActivationRoutes = {
    ROOT: "/optiopay-activation",
    ACTIVATION: "/optiopay-activation/activation",
    SUCCESS: "/optiopay-activation/success",
    SIGNING: "/optiopay-activation/signing",
    PDF: "/optiopay-activation/pdf",
    PDF_IOS: "/optiopay-activation/pdf/:webUrl",
};



// WEBPACK FOOTER //
// ./src/components/optiopayActivation/OptioPayActivationRoutes.ts